//TODO move to store/util


import {cookie_read} from './cookies'

const current_locale = ()=>{
  try{
    return cookie_read('lang')
  } catch(err){
    return 'en-US'
  }

}
export default current_locale()